import axios from 'axios'
import router from '@/router'
import store from '@/store'

export const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 15000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})
http.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response.status === 401 && window.location.pathname !== '/auth/login') {
    localStorage.removeItem('user_token')
    store.commit('LOGOUT')
    router.push({ name: 'login' })
  }
  if (error.response.status === 402) {
    router.push({ name: 'subscription' })
  }
  store.commit('loadingFail')
  return Promise.reject(error.response)
})
export default http
